import {useNewProduct} from "../../../store/contexts/NewProductContext";
import {TYPES} from "../../../store/reducers/NewProductReducer";
import DiscountTypes from "../Components/Discounts";

const PricingCard = () => {

  const {product, dispatch, errors} = useNewProduct();

  const calculateProfitMargin = (price, dealingPrice) => {
    let profitMargin = 0;

    if((price && dealingPrice)){
      profitMargin = (Math.round((((price - dealingPrice) / price * 100)+Number.EPSILON)*100))/100;
    }

    return profitMargin;
  }

  return (
    <div className="card card-flush py-4">
      <div className="card-header">
        <div className="card-title">
          <h2>Pricing</h2>
        </div>
      </div>

      <div className="card-body pt-0">
        <div className="mb-10 fv-row">
          <label className="form-label">Base Price</label>
          <input type="number" name="price" className="form-control mb-2"
                 placeholder="Product price" value={product.price ?? ""} min={0}
                 onChange={event => dispatch({
                   type: TYPES.SET_PRODUCT,
                   payload: {
                     ...product,
                     price: event.target.value,
                     profit_margin: calculateProfitMargin(event.target.value, product.dealing_price)
                   }
                 })}
          />
          {
            errors.hasOwnProperty("price") && (
              <div className="fs-7 mb-7 text-danger">{errors.price}</div>
            )
          }
          <div className="text-muted fs-7">Set the product price.</div>
        </div>
        <div className="mb-10 fv-row">
          <label className="form-label">Dealing Price</label>
          <input type="number" name="dealing_price" className="form-control mb-2"
                 placeholder="Dealing price" value={product.dealing_price ?? ""} min={0}
                 onChange={event => dispatch({
                   type: TYPES.SET_PRODUCT,
                   payload: {
                     ...product,
                     dealing_price: event.target.value,
                     profit_margin: calculateProfitMargin(product.price, event.target.value)
                   }
                 })}
          />
          {
            errors.hasOwnProperty("dealing_price") && (
              <div className="fs-7 mb-7 text-danger">{errors.dealing_price}</div>
            )
          }
          <div className="text-muted fs-7">Set the product Dealing price.</div>
        </div>

        <div className="mb-10 fv-row">
          <label className="form-label">Profit Margin</label>
          <input type="text" name="profit_margin" className="form-control mb-2"
                 placeholder="Profit margin" value={product.profit_margin ?? ""}
                 disabled={true}
          />
          {
           (parseFloat(product.profit_margin) < parseFloat(product.required_margin)) && (
              <div className="fs-7 mb-7 text-danger">Product does not meet margin requirements ({product.required_margin} %)</div>
            )
          }
        </div>
        <DiscountTypes/>
      </div>
    </div>
  )
}

export default PricingCard;